import React, {Fragment, memo, useCallback, useEffect, useMemo, useRef, useState} from 'react';
import {useSelector} from 'react-redux';

import {translate} from '@mapsight/ui/src/js/helpers/i18n';

import {useNavPos} from '../../hooks';
import {detailsFeatureSelector} from '../../mapsight-glue/store/selectors';

import Link from '../../stade/components/link';

import StarsField from './stars-field';
import RatingForm from './rating-form';


// TODOs:
// -- alle Bewertungen geignet ausgeben
// -- die Bewertung des aktuellen User hervorheben (siehe stars.jsx)

export default memo(function Ratings() {
	const navPos = useNavPos();
	const feature = useSelector(detailsFeatureSelector);

	const headingRef = useRef();

	const ratings = useMemo(
		() => {
			if (!feature?.properties?.ratings?.ratings) {
				return null;
			}
			return feature.properties.ratings.ratings.map((r) => ({
				...r,
				createDate: new Date(r.createDate),
			}));
		},
		[feature],
	);

	const [showForm, setShowForm] = useState(navPos.state?.ratingForm);
	const onShowForm = useCallback(
		(event) => {
			setShowForm(true);
			event.stopPropagation();
		},
		[],
	);

	useEffect(
		() => {
			if (headingRef.current && (navPos.state?.ratings || navPos.state?.ratingForm)) {
				// funktioniert nicht:
				// if(typeof window !== 'undefined') {
				// 	window.setTimeout(() => {
				// 			console.log('rating scrollTo', {top: headingRef.current.getBoundingClientRect().top,});
				// 			window.scrollTo({
				// 				top: headingRef.current.getBoundingClientRect().top,
				// 				// behavior: 'smooth'
				// 			});
				// 		},
				// 		100);
				// }
				if(typeof window !== 'undefined') {
					window.setTimeout(() => {
						console.log('rating scrollIntoView', {top: headingRef.current.getBoundingClientRect().top,});
						headingRef.current.scrollIntoView();
					}, 100);
				}
			}
		},
		[headingRef.current, navPos.state]
	);

	if (
		!navPos.app ||
		navPos.app.hearts
	) {
		return null;
	}

	// Hinweis: die <p> sind für die Formatierung notwenig, auch wenn kein Kommentar vorliegt
	return (
		<Fragment>
			<div
				className="stade-text stade-ratings ms3-map-row ms3-flex ms3-flex--row"
			>
				<div ref={headingRef} style={{marginTop: -30, marginBottom: 30}} />
				<header>
					<h2>{translate('ratings.heading')}</h2>
					<p>{translate('ratings.subheading')}</p>
				</header>
			</div>
			<div className="stade-text stade-ratings ms3-map-row ms3-flex ms3-flex--row">
				<div className="ms3-flex ms3-flex--column">
					<div className="ms3-panel">
						{(showForm || navPos.state?.ratingForm) && (
							<RatingForm />
						) || (
							<p><Link to={{
								pathname: `/${feature?.id}`,
								state: {ratingForm: true}
							}} onClick={onShowForm}>
								{translate('ratings.showform')}
							</Link></p>
						)}

						{!ratings?.length &&
							<p><b>{translate('ratings.nothing')}</b></p>
						}

						<RatingEntry
							rating={5}
							comment="Ein wunderschöner Ort mit hübschen Blümchen."
							author="Oster Hase"
							date={new Date(2022, 3, 14)}
							isCurrentAuthor={false}
						/>

						<RatingEntry
							rating={3}
							comment="Ein bisserle kalt, sonst ok."
							author="Weihnachts Kind"
							date={new Date(2021, 11, 24)}
							isCurrentAuthor={false}
						/>

						{ratings && ratings.map((r, idx) => (
							<RatingEntry
								key={idx}
								rating={r.rating}
								comment={r.comment}
								author={r.author}
								date={r.createDate}
								isCurrentAuthor={r.isCurrentAuthor}
							/>
						))}
					</div>
				</div>
			</div>
		</Fragment>
	);
});

const RatingEntry = memo(
	/** @param {{
	 *   rating: number,
	 *   author: string,
	 *   comment: string,
	 *   date: Date,
	 *   isCurrentAuthor: boolean,
	 * }} props */
	function RatingEntry({
		rating,
		author,
		comment,
		date,
		isCurrentAuthor: _isCurrentAuthor,
	}) {
		return (
			<Fragment>
				<h3>
					<StarsField value={rating} />
					{author}
				</h3>
				<p>
					{comment}

					<br />
					<span>
						{date.getDate().toString()}
						.
						{(date.getMonth() + 1).toString()}
						.
						{date.getFullYear().toString()}
					</span>
				</p>
			</Fragment>
		);
	}
);
